import marked, { Renderer } from "marked"
import parser from "html-react-parser"

const markdownToReact = (content: string) => {
  // @ts-ignore
  const renderer: Renderer = {
    html(html) {
      if (html.includes("embedly-card")) {
        const { width, url } = getParametrsFromHTML(html)
        return `<iframe loading="lazy" frameborder="0" allowfullscreen="1" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" width=${width} src=${url}></iframe>`
      } else {
        return html
      }
    },
    image(href, title, text) {
      return `<img loading="lazy" alt=${
        title || text
      } src="${href}?fm=webp&q=70"></img>`
    },
  }

  marked.use({ renderer })

  return parser(marked(content))
}

const getVideoEmbed = (url: string) => {
  switch (true) {
    case url.includes("vimeo"):
      return `https://player.vimeo.com/video/${getIdVimeo(url)}`
    case url.includes("youtube"):
      return `https://www.youtube.com/embed/${getIdYoutube(url)}`
  }
}

const getIdVimeo = (url: string) => url.split("vimeo.com/")[1]
const getIdYoutube = (url: string) => {
  let [_, id] = url.split("v=")
  const ampersandPosition = id.indexOf("&")
  if (ampersandPosition != -1) {
    id = id.substring(0, ampersandPosition)
  }
  return id
}

const getParametrsFromHTML = (html: string) => {
  const url = html.match(/(?<=\bhref=")[^""]*/)?.[0] || ""
  const width = html.match(/(?<=\bdata-card-width=")[^""]*/)?.[0] || "100%"

  return { width, url: getVideoEmbed(url) }
}

export default markdownToReact
